'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSessionStorageForUser = exports.removeSessionStorage = exports.writeSessionStorageForUser = exports.writeSessionStorage = exports.readSessionStorageForUser = exports.readSessionStorage = exports.removeLocalStorageForUser = exports.removeLocalStorage = exports.writeLocalStorageForUser = exports.writeLocalStorage = exports.readLocalStorageForUser = exports.readLocalStorage = exports.removeStorageForUser = exports.removeStorage = exports.writeStorageForUser = exports.writeStorage = exports.readStorageForUser = exports.readStorage = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GUEST_STORAGE_KEY = 'guest';

var dataOrDefault = function dataOrDefault(data, defaultValue) {
  return (data === null || typeof data === 'undefined') && typeof defaultValue !== 'undefined' ? defaultValue : data;
};

var readStorage = exports.readStorage = function readStorage(type, name, defaultValue) {
  var raw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  try {
    var rawData = window[type].getItem(name);
    var data = raw ? rawData : JSON.parse(rawData);
    return dataOrDefault(data, defaultValue);
  } catch (e) {
    return defaultValue;
  }
};

var readStorageForUser = exports.readStorageForUser = function readStorageForUser(type, name, userId, defaultValue) {
  var data = readStorage(type, name, {})[userId || GUEST_STORAGE_KEY];
  return dataOrDefault(data, defaultValue);
};

var writeStorage = exports.writeStorage = function writeStorage(type, name, data) {
  var raw = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  try {
    window[type].setItem(name, raw ? data : (0, _stringify2.default)(data));
  } catch (e) {/* noop */}
};

var writeStorageForUser = exports.writeStorageForUser = function writeStorageForUser(type, name, data, userId) {
  return writeStorage(type, name, (0, _extends4.default)({}, readStorage(type, name, {}), (0, _defineProperty3.default)({}, userId || GUEST_STORAGE_KEY, data)));
};

var removeStorage = exports.removeStorage = function removeStorage(type, name) {
  try {
    window[type].removeItem(name);
  } catch (e) {/* noop */}
};

var removeStorageForUser = exports.removeStorageForUser = function removeStorageForUser(type, name, userId) {
  var data = readStorage(type, name, {});
  delete data[userId || GUEST_STORAGE_KEY];
  if ((0, _keys2.default)(data) === 0) {
    removeStorage(type, name);
  } else {
    writeStorage(type, name, data);
  }
};

var LOCAL = 'localStorage';
var SESSION = 'sessionStorage';

var readLocalStorage = exports.readLocalStorage = readStorage.bind(null, LOCAL);
var readLocalStorageForUser = exports.readLocalStorageForUser = readStorageForUser.bind(null, LOCAL);
var writeLocalStorage = exports.writeLocalStorage = writeStorage.bind(null, LOCAL);
var writeLocalStorageForUser = exports.writeLocalStorageForUser = writeStorageForUser.bind(null, LOCAL);
var removeLocalStorage = exports.removeLocalStorage = removeStorage.bind(null, LOCAL);
var removeLocalStorageForUser = exports.removeLocalStorageForUser = removeStorageForUser.bind(null, LOCAL);
var readSessionStorage = exports.readSessionStorage = readStorage.bind(null, SESSION);
var readSessionStorageForUser = exports.readSessionStorageForUser = readStorageForUser.bind(null, SESSION);
var writeSessionStorage = exports.writeSessionStorage = writeStorage.bind(null, SESSION);
var writeSessionStorageForUser = exports.writeSessionStorageForUser = writeStorageForUser.bind(null, SESSION);
var removeSessionStorage = exports.removeSessionStorage = removeStorage.bind(null, SESSION);
var removeSessionStorageForUser = exports.removeSessionStorageForUser = removeStorageForUser.bind(null, SESSION);